<div class="guest-payment-method d-flex flex-column">
    <div class="d-flex flex-row align-items-center">
        <div class="d-flex flex-column w-100">
            <form [formGroup]="paymentMethodSelectedForm" class="w-100">
                <div class="d-flex flex-row mt-2 height-custom justify-content-between">
                    @if (!!creditCardNonce || !!paymentVehicle) {
                        <div class="d-flex flex-row align-items-center w-100">
                            <app-lib-card-type
                                class="d-flex credit-card__type"
                                [cardType]="!!creditCardNonce ? cardType : paymentVehicle?.PaymentSourceSubtype"
                                width="2.3em"
                            />
                            @if (!!creditCardNonce) {
                                <div class="d-flex flex-grow-1 ms-2">
                                    <app-lib-last-four-digits [lastFourDigits]="lastFourDigitsCreditCard" />
                                </div>
                            } @else {
                                <span class="ms-2 m-0 mat-subtitle-1"
                                    >NEW {{ paymentVehicle?.PaymentSourceSubtype }} CARD</span
                                >
                            }
                        </div>
                        <div class="d-flex align-items-center height-custom">
                            <button
                                id="change-credit-card"
                                mat-button
                                type="submit"
                                (click)="setCreditCardAsPaymentMethodAndRedirect()"
                                color="primary"
                            >
                                CHANGE
                            </button>
                            <mat-divider [vertical]="true" />
                            <button
                                id="delete-credit-card"
                                class="credit-card-delete"
                                mat-button
                                (click)="removeGuestPaymentMethod()"
                                color="primary"
                                type="button"
                            >
                                DELETE
                            </button>
                        </div>
                    } @else {
                        <button
                            id="add-credit-card"
                            mat-button
                            type="button"
                            (click)="setCreditCardAsPaymentMethodAndRedirect()"
                            color="primary"
                            class="mb-0 mat-subtitle-1 btn-echeck"
                        >
                            <mat-icon matIconPrefix>add</mat-icon>
                            ADD A CREDIT CARD TO PAY AS A GUEST
                        </button>
                    }
                </div>
                @if (showError && paymentMethodSelected?.value === PaymentMethods.CREDIT_CARD) {
                    <div class="ms-2 guest-payment-method-error" [ngClass]="{ invisible: !showError }">
                        {{ msgError }}
                    </div>
                }
                @if (isEcheckEnableAsGuestPayment) {
                    @if (!!echeckOTToken) {
                        <div class="d-flex flex-row align-items-center w-100">
                            <app-lib-logo-payment-method [paymentMethodName]="PaymentMethods.ECHECK" [width]="'45px'" />
                            @if (lastFourDigitsEcheck) {
                                <div class="d-flex flex-grow-1 ms-2">
                                    <app-lib-last-four-digits [lastFourDigits]="lastFourDigitsEcheck" />
                                </div>
                            }
                        </div>
                    }
                    <div class="d-flex align-items-center height-custom">
                        @if (!!echeckOTToken) {
                            <button
                                id="change-echeck"
                                mat-button
                                type="button"
                                (click)="redirectToEcheckFormRoute()"
                                color="primary"
                            >
                                CHANGE
                            </button>
                            <mat-divider [vertical]="true" />
                            <button
                                id="delete-echeck"
                                class="credit-card-delete"
                                mat-button
                                (click)="removeGuestPaymentMethod()"
                                color="primary"
                            >
                                DELETE
                            </button>
                        }
                        @if (!echeckOTToken) {
                            <button
                                id="add-echeck"
                                mat-button
                                type="button"
                                (click)="redirectToEcheckFormRoute()"
                                color="primary"
                                class="mb-0 mat-subtitle-1 btn-echeck"
                            >
                                <mat-icon matIconPrefix>add</mat-icon>
                                ADD BANK ACCOUNT (ACH)
                            </button>
                        }
                    </div>
                }
                @if (showError && paymentMethodSelected?.value === PaymentMethods.ECHECK) {
                    <div class="ms-2 guest-payment-method-error" [ngClass]="{ invisible: !showError }">
                        {{ msgError }}
                    </div>
                }
                <mat-radio-group
                    formControlName="paymentSelected"
                    class="d-flex flex-column w-100 ms-3"
                    aria-label="Select an option"
                    (change)="onSelectPaymentMethod($event)"
                >
                    @if (isAGIWalletEnable) {
                        <mat-radio-button
                            id="agi-cargo-wallet"
                            (change)="selectSprintPay()"
                            class="mt-2 height-custom"
                            color="primary"
                        >
                            <div class="d-flex flex-row align-items-center">
                                My AGI Cargo wallet hosted by CargoSprint - SprintPay&nbsp;
                                <mat-icon
                                    class="md-icon-16"
                                    [matTooltip]="helpInfoAgiWallet"
                                    matTooltipPosition="after"
                                >
                                    info
                                </mat-icon>
                            </div>
                        </mat-radio-button>
                    }

                    <mat-radio-button
                        *appHideDownload
                        id="paypal-radio"
                        [value]="PaymentMethods.PAYPAL"
                        class="d-inline-block"
                        color="primary"
                    >
                        <span class="payment-detail--method d-block">Pay with PayPal</span>
                    </mat-radio-button>
                </mat-radio-group>
            </form>
        </div>
    </div>
</div>
